export default __webpack_public_path__ + "assets/front/scss/collaborative-indexation.c341e27c55c73dd6e739c2819d3e32d3.css";